import { render, staticRenderFns } from "./ProfilePanel.vue?vue&type=template&id=2db62f00&scoped=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=js"
export * from "./ProfilePanel.vue?vue&type=script&lang=js"
import style0 from "./ProfilePanel.vue?vue&type=style&index=0&id=2db62f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db62f00",
  null
  
)

export default component.exports